module.exports = __webpack_public_path__ + "static/media/question.a34573f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tip/assets/question.svg
// module id = 799
// module chunks = 20